import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Alert, Col, Row, Spinner } from 'react-bootstrap';
import { getOrgs } from '../../redux/organization/actions';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarDashboard from '../../components/SidebarDashboard';

const Orgs = props => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const data = useSelector(store => store.orgs.orgs);
  const loading = useSelector(store => store.orgs.loading);
  const userRoles = useSelector(store => store.auth.userRoles);
  useEffect(() => {
    dispatch(getOrgs(parseInt(props.match.params.type)));
  }, [dispatch, props.match.params.type]);

  let orgs = [];
  if(data.length > 0 && userRoles.includes('alta_direccion')){
    data.map(item => {
      if(item.codigo !== '2400' && 
         item.codigo !== '1570' &&
         item.codigo !== '1550' &&
         item.codigo !== '1510' &&
         item.codigo !== '1500'){
        orgs = [...orgs, item];
      }
    });
  }else{
    orgs = data;
  }
  
  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={'dashboard'} onShowSidebar={onShowSidebar}  />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-4">
            <h5 className="font-weight-bold">¿CUÁL ESTRUCTURA DESEA VER?</h5>
            <hr />
          </div>
          {
            loading ? (
              <div className="d-flex justify-content-center mt-4">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ): data.length === 0 ? (
              <Alert
                className="my-4" 
                variant="info">
                Aún no hay empresas registradas para mostrar la estructura
              </Alert>
            ):(
              <Row>
                {
                  orgs.map(item => (
                    <Col md="3" className="mb-2">
                      <Link 
                        style={{height: '100px'}} 
                        //to={parseInt(props.match.params.type) === 1 ? `/estructura-organizacional/${item.id}/${item.nombre}/` : `/funcional-estructura-organizacional/${item.id}/${item.nombre}/`} 
                        to={`/estructura-organizacional/${item.id}/${item.nombre}/${props.match.params.type}`} 
                        className="btn btn-primary d-flex justify-content-center align-items-center">
                          {item.nombre}</Link>
                    </Col>
                  ))
                }
              </Row>
            )
          }
        </div>
      </div>
    </>
  )
}

export default Orgs
